import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useEffect, useState } from "react";

const BarGraphChart = ({ graphData, graphDataSecond }) => {
  console.log(graphData);
  console.log(graphDataSecond);

  const [isCheckedInput, setIsCheckedInput] = useState(false);
  const [mainGraphData, setMainGraphData] = useState(
    isCheckedInput ? graphDataSecond : graphData
  );

  useEffect(() => {
    setMainGraphData(isCheckedInput ? graphDataSecond : graphData);
  }, [isCheckedInput, graphDataSecond, graphData]);

  const changeButtonStatus = (e) => {
    setIsCheckedInput(e.target.checked);
  };

  return (
    <div className="AcademicBarGraph">
      <div className="title-header">
        <h3>Academic break down</h3>
        <span>
          <div className="toggleBtn">
            <label htmlFor={"rbd"}>Residential break down</label>
            <input
              type={"checkbox"}
              name={"rbd"}
              checked={isCheckedInput}
              onChange={changeButtonStatus}
              required
            />
          </div>
        </span>
        <SelectFilter />
      </div>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={mainGraphData}
          margin={{ top: 20, right: 30, left: 20, bottom: 60 }} // Increased bottom margin for rotated labels
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="category"
            textAnchor="end"
            height={60}
            interval={0} // Ensures all labels are shown
            tick={{ angle: -45, dy: 10, dx: -5, fontSize: 12 }} // Rotate labels to fit
          />
          <YAxis
            label={{ value: "Amount (₹)", angle: -90, position: "insideLeft" }}
            domain={[0, 45000]}
            ticks={[
              0, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000,
            ]}
            tickFormatter={(value) => `${value / 1000}k`}
          />
          <Tooltip formatter={(value) => `₹${value}`} />
          <Bar dataKey="amount" fill={isCheckedInput ? "#FF75BA" : "#6A2FFF"} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarGraphChart;
